import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { GET, httpOk } from 'helpers/api'
import { FilterBar, DeptSelect, getDateRange, mln, ABC_COLOR, ABC_CAT, TA_CSS } from './tovarShared'

function AbcProducts() {
	const { t } = useTranslation()
	const [data, setData] = useState({ items: [], summary: null, total: 0, qty_total: 0, a_count: 0 })
	const [quick, setQuick] = useState('month')
	const [range, setRange] = useState(getDateRange('month'))
	const [custom, setCustom] = useState({ start: null, end: null })
	const [dept, setDept] = useState('')

	const load = useCallback(async (r, dp) => {
		const params = { start_date: r.start, end_date: r.end }
		if (dp) params.department = dp
		const res = await GET('/analytics/abc-products', params, { loader: true })
		if (httpOk(res)) setData(res.data)
	}, [])

	useEffect(() => { load(range, dept) }, [range, dept, load])

	function onQuick(id) { setQuick(id); setCustom({ start: null, end: null }); setRange(getDateRange(id)) }
	function onCustom(s, e) {
		setCustom({ start: s, end: e })
		if (s && e) { setQuick(''); const f = d => d.toISOString().slice(0, 10); setRange({ start: f(s), end: f(e) }) }
	}

	const s = data.summary
	return (
		<>
			<style>{TA_CSS}</style>
			<div className="ta">
				<div className="ta-head">
					<div>
						<h4>{t('abc_products')}</h4>
						<div className="ta-hint">{t('abc_products_hint')}</div>
					</div>
					<div className="ta-tools">
						<DeptSelect value={dept} onChange={setDept} t={t} />
						<FilterBar quick={quick} custom={custom} onQuick={onQuick} onCustom={onCustom} t={t} />
					</div>
				</div>

				{/* KPI */}
				<div className="ta-kpis">
					<div className="ta-kpi">
						<div className="ta-kpi-ic" style={{ background: '#eef2ff', color: '#4f46e5' }}><i className="uil-invoice" /></div>
						<div className="ta-kpi-l">{t('abc_kpi_sum')}</div>
						<div className="ta-kpi-v">{mln(data.total)}</div>
						<div className="ta-kpi-s">{data.items.length} {t('goods')}</div>
					</div>
					<div className="ta-kpi">
						<div className="ta-kpi-ic" style={{ background: 'var(--cat-ok-bg, #ecfdf5)', color: 'var(--ok-mid, #059669)' }}><i className="uil-chart" /></div>
						<div className="ta-kpi-l">{t('abc_kpi_qty')}</div>
						<div className="ta-kpi-v">{mln(data.qty_total)}</div>
						<div className="ta-kpi-s">{t('for_period')}</div>
					</div>
					<div className="ta-kpi">
						<div className="ta-kpi-ic" style={{ background: '#fffbeb', color: '#d97706' }}><i className="uil-star" /></div>
						<div className="ta-kpi-l">{t('abc_kpi_a')}</div>
						<div className="ta-kpi-v">{data.a_count}</div>
						<div className="ta-kpi-s">{t('cat_critical')}</div>
					</div>
				</div>

				{/* Kategoriyalar A/B/C */}
				{s &&
					<div className="ta-catrow">
						{['A', 'B', 'C'].map(k => {
							const c = ABC_CAT[k]
							return (
								<div className="ta-cat" key={k} style={{ background: c.bg, borderColor: c.bd, color: c.color }}>
									<div className="ta-cat-ic" style={{ color: c.color }}><i className="uil-chart-pie" /></div>
									<div className="ta-cat-t">{t('category')} {k}</div>
									<div className="ta-cat-sub" style={{ color: c.color }}>{t(c.sub)}</div>
									<div className="ta-cat-v">{mln(s[k].value)}</div>
									<div className="ta-cat-s">{s[k].count} {t('goods')} · {data.total > 0 ? Math.round(s[k].value / data.total * 100) : 0}%</div>
								</div>
							)
						})}
					</div>}

				{/* Jadval */}
				<div className="ta-block">
					<div className="ta-block-h">
						<i className="uil-cell me-1" />{t('abc_products')}
						<span className="ta-pill" style={{ marginLeft: 8, background: '#f1f5f9', color: '#475569' }}>{data.items.length} {t('goods')}</span>
					</div>
					<div className="ta-scroll">
						<table className="ta-tbl">
							<thead>
								<tr>
									<th style={{ width: 36 }}>#</th>
									<th>{t('name')}</th>
									<th className="ta-num">{t('qty_col')}</th>
									<th className="ta-num">{t('revenue_sum')}</th>
									<th className="ta-num">{t('share')}</th>
									<th className="text-center" style={{ width: 56 }}>ABC</th>
									<th className="ta-num">{t('in_stock')}</th>
									<th className="ta-num">{t('stock_value_col')}</th>
								</tr>
							</thead>
							<tbody>
								{data.items.map((r, i) => (
									<tr key={r.id}>
										<td className="ta-num" style={{ color: '#94a3b8' }}>{i + 1}</td>
										<td>
											<div className="fw-semibold">{r.name}</div>
											<div className="ta-sub">{r.unit || '—'} · {r.cheques} {t('cheques')}</div>
										</td>
										<td className="ta-num">{mln(r.qty)} {r.unit}</td>
										<td className="ta-num fw-semibold">{mln(r.revenue)}</td>
										<td className="ta-num" style={{ color: '#64748b' }}>{r.share}%</td>
										<td className="text-center"><span className="ta-badge" style={{ background: ABC_COLOR[r.abc] }}>{r.abc}</span></td>
										<td className="ta-num" style={{ color: r.stock_qty < 0 ? 'var(--warn-ink, #dc2626)' : 'var(--ink-strong, #0f172a)' }}>{mln(r.stock_qty)} {r.unit}</td>
										<td className="ta-num fw-semibold" style={{ color: r.stock_value < 0 ? 'var(--warn-ink, #dc2626)' : 'var(--ink-strong, #0f172a)' }}>{mln(r.stock_value)}</td>
									</tr>
								))}
								{data.items.length === 0 && <tr><td colSpan={8} className="ta-empty">{t('no_data')}</td></tr>}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	)
}

export default AbcProducts
